import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/app/layouts/default.vue").then(m => m.default || m)),
  embed: defineAsyncComponent(() => import("/app/layouts/embed.vue").then(m => m.default || m)),
  unauthenticated: defineAsyncComponent(() => import("/app/layouts/unauthenticated.vue").then(m => m.default || m))
}